var _excluded = ["onPageChange", "onSizeChange", "selectableSizes", "count", "pageSize", "pageNumber"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { createContext } from '@chakra-ui/react-utils';
import { chakra, StylesProvider, useMultiStyleConfig } from '@chakra-ui/system';
import React from 'react';
import { pageStateResolver } from './utils';
export var [PaginationProvider, usePaginationContext] = createContext({
  name: 'PaginationContext',
  errorMessage: // eslint-disable-next-line max-len
  'usePaginationContext: `context` is undefined. Seems you forgot to wrap Page components in `<Pagination />`'
});
export var Pagination = _ref => {
  var {
    onPageChange,
    onSizeChange,
    selectableSizes,
    count,
    pageSize,
    pageNumber
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var styles = useMultiStyleConfig('Pagination', _extends({}, props));
  var pageState = pageStateResolver({
    count,
    pageNumber,
    pageSize
  });
  return /*#__PURE__*/React.createElement(PaginationProvider, {
    value: _extends({
      selectableSizes,
      onPageChange,
      onSizeChange
    }, pageState)
  }, /*#__PURE__*/React.createElement(StylesProvider, {
    value: styles
  }, /*#__PURE__*/React.createElement(chakra.div, _extends({
    display: "flex",
    flexWrap: "wrap",
    gap: "15px",
    justifyContent: "center"
  }, props))));
};
//# sourceMappingURL=pagination.js.map